import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../utilities/hooks/useAuth';

function Resourcehub() {
  const { user } = useAuth();

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  const domain = 'https://resourcehub.intellect.co/';

  const params = new URLSearchParams(window.location.search);
  const embeddedUrl = params.get('url');

  const url = new URL(window.location.href);
  const hasSentUserId = useRef(false);
  const handleIframeLoad = () => {
    // Send userId only once during the first iframe load
    if (!hasSentUserId.current && user && iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage({ userId: user.id }, domain);
      hasSentUserId.current = true; // Mark as sent
    }

    // Send embeddedUrl (can send multiple times if required)
    if (embeddedUrl && iframeRef.current?.contentWindow) {
      iframeRef.current.contentWindow.postMessage('url', domain);
    }
  };

  useEffect(() => {
    if (embeddedUrl && iframeRef.current) {
      iframeRef.current.src = `${domain}/${embeddedUrl}`;
    }
  }, [embeddedUrl]);

  window.addEventListener('message', function (event) {
    if (event.data.type === 'updateUrl') {
      const receivedUrl = event.data.url;

      if (receivedUrl !== '/') {
        url.searchParams.set('url', receivedUrl);
        window.history.pushState({}, '', url.href);
      } else {
        const url = new URL(window.location.href);
        url.searchParams.delete('url');
        window.history.pushState({}, '', url.href);
      }
    }

    if (event.data === 'replace') {
      url.searchParams.delete('url');
      navigate(url.pathname + url.search, { replace: true });
    }
  });

  return (
    <div>
      <iframe
        ref={iframeRef}
        id="childFrame"
        src={embeddedUrl || 'https://resourcehub.intellect.co'}
        className="h-[calc(100vh-72px)] w-full"
        title="Intellect iFrame"
        onLoad={handleIframeLoad}
      ></iframe>
    </div>
  );
}

export default Resourcehub;
